import React, { useState, useEffect } from "react";
import QRCode from "qrcode.react";
import "./UserConfirms.modules.css";
import { useTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";
import * as AppUrls from "../../../constants/AppUrls";
import NavbarOnboarding from "../NavbarOnboarding/NavbarOnboarding";
import KYCimg from "../../../assets/images/Sharjah/KYC.png";
import { useLocation } from "react-router-dom";
import * as Helpers from "../../../global/Helpers";
import * as utils from "../../../global/utils";
import * as Constants from "../../../constants/Constants";
import i18next from "i18next";
import { CloudArrowUp } from "react-bootstrap-icons";
import SessionExpiredPOPup from "../SessionExpiredPOPup/SessionExpiredPOPup";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const UserConfirms = () => {
  ;
  const location = useLocation();

  const VerifymyEIDType = location.state || null;
  const { t } = useTranslation();

  const [redirect, setRedirect] = useState(null);
  const [IBAN, setIBAN] = useState("AE070331234567890123456");
  const [IBANValidate, setIBAN_Validate] = useState("");
  const [isVerify, setisVerify] = useState(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState(false);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");

  const handleChange = (e) => {
    setIBAN_Validate(e.target.value);
  };
  const onclickVerifymyEID = (e) => {
    var Items = [
      { ID: "30", Value: IBAN },
      { ID: "258", Value: "1" },
    ];
    saveKycData(Items, AppUrls.OnboardingNonSIBAccount);
    // setRedirect(AppUrls.onboardingProfileConfirms)
  };
  const handleBack = (e) => {
    e.preventDefault();
    setRedirect(AppUrls.onboardingPersonal);
  };
  const onclickValidateEID = (e) => {
    var Items = [];

    var result = Helpers.getScreenIdByGroupAndName("Confirm Account");

    if (VerifymyEIDType !== null && VerifymyEIDType !== undefined) {
      if (VerifymyEIDType.isInternational) {
        Items = [
          { ID: "258", Value: "1" },
          { ID: "288", Value: result?.GROUP_ID || "" },
          { ID: "287", Value: result?.SCREEN_ID || "" },
        ];

        if (IBANValidate !== "") {
          Items.push({ ID: "278", Value: IBANValidate });
        } else {
          Helpers.errorNotify(t("Please fill IBAN number"), i18next.language);
          return;
        }
      } else {
        Items = [
          { ID: "30", Value: IBANValidate },
          { ID: "258", Value: "1" },
          { ID: "288", Value: result?.GROUP_ID || "" },
          { ID: "287", Value: result?.SCREEN_ID || "" },
        ];
      }
    } else {
      Items = [
        { ID: "30", Value: IBANValidate },
        { ID: "258", Value: "1" },
        { ID: "288", Value: result?.GROUP_ID || "" },
        { ID: "287", Value: result?.SCREEN_ID || "" },
      ];
    }

    //  saveKycData(Items, AppUrls.OnboardingNonSIBAccount)
    saveKycData(Items, AppUrls.OnboardingNonSIBAccount);
  };

  const CallInsertAttachments = async (RedirectPath) => {
    if (!file) {
      Helpers.successNotify(t("PleaseUpdateYourExpiredDocuments"));
      return;
    }

    var arrayofbyte = await Helpers.getAsByteArray(file);
    var bytesString = [].slice.call(arrayofbyte);

    var FileType = file.type;
    FileType = FileType.split("/");
    if (FileType !== null) FileType = FileType[1];

    const body = {
      fields: [
        { DocType: FileType, field_id: "168", field_value: bytesString },
      ],
      RequestId: localStorage.getItem("RID"),
    };

    var response = utils.CallInsertAttachments(
      Constants.InsertAttachments,
      body
    );
    await response
      .then((response) => {
        ;
        if (response.data.ErrorMsg === "success") {
          Helpers.successNotify(t("FileUplodedSuccessfully"));
          setRedirect(RedirectPath);
        } else if (response.data.ErrorMsg === "Invalid token") {
          confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <SessionExpiredPOPup
                  setRedirect={setRedirect}
                  onClose={onClose}
                />
              );
            },
          });
        } else {
          Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
        }
      })
      .catch((error) => {
        console.log("CallInsertAttachments", error);
      });
  };
  function validateSubmit(value) {
    ;
    if (!file)
      if (value === "") {
        Helpers.errorNotify(t("Please fill IBAN number"), i18next.language);
        return false;
      }
    return true;
  }
  const saveKycData = async (Items, RedirectPath) => {
    ;
    try {
      if (!validateSubmit(Items[0].Value)) return;

      if (file) {
        CallInsertAttachments(RedirectPath);
      }

      if (IBANValidate !== "") {
        const body = {
          RequestItems: Items,
          reqID: localStorage.getItem("RID"),
        };
        var response = utils.CallKYCAPI(Constants.GetKYCCibc, body);
        await response
          .then((response) => {
            ;
            if (response.data.Error_code === "0") {
              setRedirect(RedirectPath);
            } else if (response.data.Error_code === "-1") {
              confirmAlert({
                customUI: ({ onClose }) => {
                  return (
                    <SessionExpiredPOPup
                      setRedirect={setRedirect}
                      onClose={onClose}
                    />
                  );
                },
              });
            } else {
              Helpers.errorNotify(response.data.Error_Msg, i18next.language);
            }
          })
          .catch((error) => {
            console.log("saveKycData", error);
          });
      }
    } catch (error) {
      console.error("Error posting data saveKycData:", error);
    }
  };

  const handleCheckboxChange = (event) => {
    ;
    const { value, checked } = event.target;
    if (checked) {
      setSelectedCheckboxes(false);
    } else {
      setSelectedCheckboxes(true);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();

    const file = event.dataTransfer.files[0];
    if (file) {
      setFileName(file.name);
      setFile(file);
    }
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.files[0]);
    if (file) setFileName(file.name);
  };

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <>
      <NavbarOnboarding />
      <div className="login-main-container">
        <div className="KYCDivImg">
          <h2 className="OpenYourAccountwithUs">{t("OpenYourAccountwithUs")}</h2>
          <img className="KYCImg" src={KYCimg} />
        </div>

        <div className="UserConfirms-container">
          <div className="UserConfirms-form">
            <div className="">
              {/* {VerifymyEIDType !== null && VerifymyEIDType !== undefined ?
                                VerifymyEIDType.ExistingSIB ?
                                    <div className='mb-3' style={{ borderBottom: "1px solid #e6dacb" }}>
                                        <h2 style={{ fontWeight: "500" }}>{t('UserConfirmsText')}</h2>
                                        <span>{t('IBAN')} :</span>
                                        <span >{IBAN}</span>
                                        <button className="UserConfirms-button mb-3 mt-3" onClick={(e) => onclickVerifymyEID(e)}>{t("Confirm")}</button>
                                    </div>
                                    : null
                                : null
                            } */}
              {/* {VerifymyEIDType !== null && VerifymyEIDType !== undefined ?
                                VerifymyEIDType.NonSIB || VerifymyEIDType.OpenAccountSIB || VerifymyEIDType.isInternational ?
                                    <div className='mb-3' style={{ borderBottom: "1px solid #e6dacb" }}>
                                        <h2 style={{ fontWeight: "500" }}>{t('openSIBaccount')}</h2>

                                        <a href='https://www.google.com/' target='_blank'> <button className="UserConfirms-button mb-3 mt-3">  {t('OPEN_SIB')}</button></a>
                                    </div>
                                    : null
                                : null
                            } */}

              <div>
                {VerifymyEIDType !== null && VerifymyEIDType !== undefined ? (
                  VerifymyEIDType.isInternational ? (
                    <>
                      <span>{t("IBANCertificate")}</span>
                      <div className="upload-container-new mt-4">
                        <label for="file-input" class="browse-link">
                          <div
                            className="drag-drop-area  mb-4"
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={handleDrop}
                          >
                            <CloudArrowUp size={30} color="gray" />
                            <p>
                              {i18next.language === "ar"
                                ? "اسحب وأفلِت الملف هنا"
                                : "Drag & drop file here"}
                              <span>
                                {i18next.language === "ar" ? "أو" : "or"}
                              </span>
                              <label for="file-input" class="browse-link">
                                {t("browseFile")}
                              </label>{" "}
                              {i18next.language === "ar"
                                ? "من الجهاز"
                                : "from device"}
                            </p>
                            <input
                              id="file-input"
                              type="file"
                              onChange={handleFileChange}
                              hidden
                            />
                          </div>
                        </label>
                        {fileName && (
                          <p className="file-name">
                            {i18next.language === "ar"
                              ? "الملف المحدد:"
                              : "Selected File:"}{" "}
                            {fileName}
                          </p>
                        )}
                      </div>
                    </>
                  ) : null
                ) : null}
                <span>{t("enterOtherIBAN")}</span>
                <div
                  style={{ justifyContent: "space-between", display: "flex" }}
                >
                  <input
                    type="text"
                    id="textIBAN"
                    name="textIBAN"
                    value={IBANValidate}
                    onChange={handleChange}
                    style={{ margin: "5px" }}
                    required
                  />
                  {/* {VerifymyEIDType !== null && VerifymyEIDType !== undefined ? (
                    VerifymyEIDType.isInternational ? (
                      <div className="">
                        <label htmlFor="file-upload" className="UserConfirms-upload-icon">
                          <input style={{ border: "0", display: "none" }} id="file-upload" type="file" onChange={handleFileChange}></input>
                        </label>
                        {fileName && <p className="file-name">Selected File: {fileName}</p>}
                      </div>
                    ) : null
                  ) : null} */}
                </div>

                {/* {VerifymyEIDType !== null && VerifymyEIDType !== undefined ? (
                  VerifymyEIDType.isInternational ? (
                    <span>
                      <input type="checkbox" value="Option 1" onChange={handleCheckboxChange} />
                      <span>{t("ConsentIBANForEFTS")}</span>
                    </span>
                  ) : null
                ) : null} */}

                <button
                  className="UserConfirms-button mt-3"
                  onClick={(e) => onclickValidateEID(e)}
                >
                  {t("Validate")}
                </button>
              </div>
              <div>
                {/* <button
                  className={"link"}
                  style={{
                    width: "100%",
                    textDecoration: "underline",
                    marginTop: "1rem",
                    marginLeft: "auto",
                    marginRight: "auto",
                    background: "transparent",
                    border: "none",
                    color: "#0b1d81",
                    cursor: "pointer",
                  }}
                  onClick={handleBack}>
                  {t("back")}
                </button> */}
                {/* <button className="backBtn" onClick={handleBack}>
                  {t("back")}
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserConfirms;
